const career = [
  {
    company: "Leitner Revenue Systems",
    roles: [{ title: "Founder & Principal Consultant", dates: "Dec 2025 – Present" }],
    highlights: ["Advising growth-stage B2B companies on Sales Development, pipeline creation, and AI-assisted prospecting workflows."]
  },
  {
    company: "Paystand",
    roles: [{ title: "Senior Director, Sales Development", dates: "Sep 2023 – Dec 2025" }],
    highlights: [
      "Led ~40 SDRs at peak through four frontline leaders across four offices.",
      "Tripled output with 36% fewer staff; grew meetings 300%+ YoY.",
      "Sales Development sourced 79% of company pipeline.",
      "Nearly two-thirds of President's Club winners started as SDRs.",
      "Cross-functional partner to the CSO and Marketing; introduced AI-enabled prospecting with Artisan, Nooks, Reachdesk, and Sendoso."
    ]
  },
  {
    company: "Ushur",
    roles: [
      { title: "Director, Sales Development", dates: "Jun 2022 – Sep 2023" },
      { title: "Senior Manager, Enterprise Sales Development & Operations", dates: "Apr 2021 – Jun 2022" }
    ],
    highlights: [
      "Built the SDR function from the ground up.",
      "$25M+ opportunity pipeline and $5.4M closed-won ARR.",
      "Sales Accepted Leads up 232% YoY; 35% meeting-to-opportunity conversion.",
      "Partnered with Revenue Operations to build industry GTM pods across insurance, healthcare, and financial services."
    ]
  },
  {
    company: "Paystand",
    roles: [
      { title: "Head of Sales Development", dates: "Apr 2020 – Apr 2021" },
      { title: "Account Executive", dates: "Sep 2019 – Apr 2020" },
      { title: "Sales Development Representative", dates: "Apr 2019 – Aug 2019" }
    ],
    highlights: [
      "SDR: 154% and 143% of quota; sourced 23.4% of 2019 sales revenue.",
      "AE: 110% and 105% of quota while hiring and training six BDRs.",
      "Head of SD: scaled BDR org from 13 to 20 reps; promoted three BDRs to AE."
    ]
  }
];

const progression = ["SDR", "AE", "Head of Sales Development", "Director", "Senior Director"];

const RoleCard = ({ item, index }) => (
  <div className="relative pl-8 sm:pl-10 pb-10 last:pb-0" data-testid={`experience-item-${index}`}>
    <div className="absolute left-0 top-1.5 w-3.5 h-3.5 rounded-full bg-[#D4AF37] ring-4 ring-[#D4AF37]/20" />
    <h3 className="text-xl sm:text-2xl font-semibold text-white mb-3">{item.company}</h3>
    <div className="space-y-1.5 mb-4">
      {item.roles.map((r) => (
        <div key={r.title} className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-0.5 sm:gap-4">
          <span className="text-[#D4AF37] font-medium text-sm sm:text-base">{r.title}</span>
          <span className="text-xs sm:text-sm font-mono text-zinc-400 flex-shrink-0">{r.dates}</span>
        </div>
      ))}
    </div>
    <ul className="space-y-1.5">
      {item.highlights.map((h) => (
        <li key={h} className="text-sm sm:text-base text-zinc-300 leading-relaxed flex gap-2">
          <span className="text-[#D4AF37]">—</span>{h}
        </li>
      ))}
    </ul>
  </div>
);

export const ExperienceSection = () => (
  <section id="experience" className="py-12 sm:py-16 lg:py-20 bg-[#0A0A0A]" data-testid="experience-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="text-xs sm:text-sm font-mono text-[#D4AF37] tracking-widest uppercase mb-3">Experience</div>
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight mb-6">From the phones to the org chart.</h2>

      <div className="flex flex-wrap items-center gap-2 mb-12" data-testid="career-progression">
        {progression.map((step, i) => (
          <div key={step} className="flex items-center gap-2">
            <span className={`px-3 py-1.5 rounded-full text-xs sm:text-sm border ${i === progression.length - 1 ? "bg-[#D4AF37] text-[#0A0A0A] border-[#D4AF37] font-semibold" : "border-[#D4AF37]/30 text-zinc-200"}`}>{step}</span>
            {i < progression.length - 1 && <span className="text-[#D4AF37]">→</span>}
          </div>
        ))}
      </div>

      <div className="relative">
        <div className="absolute left-[6px] top-2 bottom-2 w-px bg-[#D4AF37]/25" />
        {career.map((item, i) => <RoleCard key={`${item.company}-${i}`} item={item} index={i} />)}
      </div>
      <p className="mt-10 pl-8 sm:pl-10 text-xs sm:text-sm text-zinc-500" data-testid="early-career-note">
        <span className="font-mono uppercase tracking-widest text-[#D4AF37]/70 mr-2">Origins</span>
        Started through SV Academy's Business Development Fellowship (Cohort 17) and a BDR internship at Palo Alto Networks.
      </p>
    </div>
  </section>
);

export default ExperienceSection;
